<template>
  <section class="contact-me">
    <bacon title="Let's make some Art!"></bacon>
    <h3 class="two-line-heading">I am based in Chicago,
      <span>But I work with clients from all over world.</span>
    </h3>
    <a href="/contact" class="button">Contact Me!</a>
  </section>
</template>

<script>
  import Bacon from './bacon.vue'

  export default {
    components: {Bacon},

    props: {
      id: String,
      name: String,
    },
  }
</script>

<style lang="scss">
  @import "../../css/contact-me.scss";
</style>


// WEBPACK FOOTER //
// contact-me.vue?9c340b50